import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Navbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faBug, faTerminal, faCodeBranch, faLaptopCode, faCogs } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Styles/Navbar.css';

function Navigation() {
    const [navbar, setNavbar] = useState(false);
    const [currentIcon, setCurrentIcon] = useState(0);
    const icons = [faCode, faBug, faTerminal, faCodeBranch, faLaptopCode, faCogs];
    const [expanded, setExpanded] = useState(false);

    const changeBackground = () => {
        if (window.scrollY >= 80) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    useEffect(() => {

        window.addEventListener('scroll', changeBackground);

        const iconInterval = setInterval(() => {
            setCurrentIcon((prevIcon) => (prevIcon + 1) % icons.length);
        }, 3000);

        return () => {
            window.removeEventListener('scroll', changeBackground);
            clearInterval(iconInterval);
        };
    }, [icons.length]);

    const closeNavbar = () => {
        setExpanded(false);
    };

    return (
        <Navbar expand="lg" fixed="top" className={navbar ? "navbar-batman scroll" : "navbar-batman"} expanded={expanded}
        onToggle={(expanded) => setExpanded(expanded)}>
            <Navbar.Brand as={Link} to="hero" smooth={true} duration={500} spy={true}>
                <FontAwesomeIcon icon={icons[currentIcon]} className="brand-icon" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className="navbar-toggler-icon"></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Nav>
                    <Nav.Link as={Link} to="hero" smooth={true} duration={500} offset={-60} className="nav-link-batman" onClick={closeNavbar}>Hero</Nav.Link>
                    <Nav.Link as={Link} to="about" smooth={true} duration={500} offset={-40} className="nav-link-batman" onClick={closeNavbar}>About</Nav.Link>
                    <Nav.Link as={Link} to="skills" smooth={true} duration={500} offset={-40} className="nav-link-batman" onClick={closeNavbar}>Skills</Nav.Link>
                    <Nav.Link as={Link} to="experience" smooth={true} duration={500} offset={-40} className="nav-link-batman" onClick={closeNavbar}>Experience</Nav.Link>
                    <Nav.Link as={Link} to="projects" smooth={true} duration={500} offset={-40} className="nav-link-batman" onClick={closeNavbar}>Projects</Nav.Link>
                    <Nav.Link as={Link} to="contact" smooth={true} duration={500} offset={-40} className="nav-link-batman" onClick={closeNavbar}>Contact</Nav.Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default Navigation;